import fetch from '@/libs/fetch'

export default class User {
	/**
	 * @description 用户登录
	 * @param {Object}  data  name:用戶名  password:用户密码
	 */
	static async login(data) {
		return await fetch({
			url: 'agent/auth/login',
			method: 'post',
			data
		})
	}
	/**
	 * @description 获取当前登录用户信息
	 * @param {*}
	 */

	static async getUserInfo() {
		return await fetch({
			url: 'agent/auth/currAgent',
			method: 'post'
		})
	}
	/**
	 * @description 用户退出登录
	 *
	 */

	static async logout() {
		return await fetch({
			url: 'agent/auth/logout',
			method: 'post'
		})
	}

	/**
	 * @description  刷新token
	 */
	static async refreshToken() {
		return await fetch({
			url: 'agent/auth/refresh',
			method: 'post'
		})
	}

	/**
	 * @description 修改密码
	 * @param {Obejct} data  current_pass:旧密码  password:新密码   password_configmation:重复新密码
	 *
	 */
	static async resetPassword(data) {
		return await fetch({
			url: 'agent/auth/pass/reset',
			method: 'patch',
			data
		})
	}

	/**
	 * @description 修改昵称
	 * @param {Obejct} data  nickname: 昵称
	 *
	 */
	static async updateInfo(data) {
		return await fetch({
			url: 'agent/auth/update',
			method: 'patch',
			data
		})
	}
}
